import {ScreenName} from 'navigations/Screens';
import strings from '../translations';

export const generateTabTitleForBreadCrumbs = (
  value: string,
  dynamicTitle: string | undefined,
) => {
  switch (value) {
    case ScreenName.home:
      return strings.tabbar.classes;
    case ScreenName.createClass:
      return strings.createClassScreen.createClass;
    case ScreenName.analytics:
      return ScreenName.analytics;
    case ScreenName.charts:
      return ScreenName.charts;
    // return dynamicTitle;
    case ScreenName.transcriptions:
      return `${ScreenName.transcriptions}`;
    case ScreenName.analytics:
      return strings.analyticsScreen.analytics;
    case ScreenName.analyticInfo:
      return dynamicTitle;
    case ScreenName.adminPanelGroupsInteraction:
      return strings.admin.editGroup;
    case ScreenName.adminPanelGroups:
      return strings.admin.group;
    default:
      return '';
  }
};
